import React, { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import { convertIstToUtc } from "../../common/TimeUtils";
import { getUserEarning } from "../../redux/services/contestEarningSlice";

const UserEarning = () => {
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(false);
  const [savedStartDate, setSavedStartDate] = useState(null);
  const [savedEndDate, setSavedEndDate] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const getUserWiseEarningData = useSelector(
    (state) => state.contestEarning.userWiseData
  );
  const handleDateSubmit = () => {
    let adjustedStartDate = null;
    if (startDate) {
      adjustedStartDate = new Date(startDate);
      adjustedStartDate.setHours(0, 0, 0, 0);
    }

    let adjustedEndDate = null;
    if (endDate) {
      adjustedEndDate = new Date(endDate);
      adjustedEndDate.setHours(23, 59, 59, 999);
    }
    const SDate = adjustedStartDate ? convertIstToUtc(adjustedStartDate) : null;
    const EDate = adjustedEndDate ? convertIstToUtc(adjustedEndDate) : null;
    if (SDate && EDate) {
      setToggle(false);
      getAllUserWiseEarning(SDate, EDate);
      setStartDate(
        convertIstToUtc(moment().subtract(24, "hours").toISOString())
      );
      setEndDate(convertIstToUtc(moment().toISOString()));
    } else {
    }
    return { SDate, EDate };
  };
  const handleSaveDate = () => {
    setSavedStartDate(startDate);
    setSavedEndDate(endDate);
    if (handleDateSubmit) {
      handleDateSubmit();
    }
  };
  const getAllUserWiseEarning = useCallback(
    async (startDate, endDate) => {
      const SDate = startDate
        ? startDate
        : convertIstToUtc(moment().subtract(24, "hours").toISOString());
      const EDate = endDate ? endDate : convertIstToUtc(moment().toISOString());
      const payload = { startDate: SDate, endDate: EDate };
      try {
        const response = await dispatch(getUserEarning(payload));
        if (response.payload.status === 200) {
          setStartDate("");
          setEndDate("");
        }
      } catch (error) {}
    },
    [dispatch]
  );

  useEffect(() => {
    getAllUserWiseEarning();
  }, [getAllUserWiseEarning]);
  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    { header: "Name", key: "name", render: (_, row) => row?.name || "-" },
    {
      header: "Reffreal Code",
      key: "referralCode",
      render: (_, row) => row?.referralCode || "-",
    },
    { header: "Contact", key: "contact", render: (_, row) => row?.contact || "-" },
    {
      header: "Today Contest",
      key: "todayContestCount",
      render: (_, row) => (row?.todayContestCount !== undefined && row?.todayContestCount !== null ? row.todayContestCount : "-"),
    },
    {
      header: "Total Contest",
      key: "totalContestCount",
      render: (_, row) => (row?.totalContestCount !== undefined && row?.totalContestCount !== null ? row.totalContestCount : "-"),
    },
    {
      header: "Today Earning",
      key: "todayEarnings",
      render: (_, row) =>(row?.todayEarnings !== undefined && row?.todayEarnings !== null ? row.todayEarnings : "-")
    },
    {
      header: "Total Earning",
      key: "totalEarnings",
      render: (_, row) =>(row?.totalEarnings !== undefined && row?.totalEarnings !== null ? row.totalEarnings : "-")
    },
  ];
  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    setSavedStartDate("");
    setSavedEndDate("");
    if (handleDateSubmit) {
      handleDateSubmit();
    }
  };
  return (
    <div>
      <Table
        title="User Earning"
        columns={columns}
        data={getUserWiseEarningData}
        dateFilter={true}
        toggle={toggle}
        setToggle={setToggle}
        savedStartDate={savedStartDate}
        savedEndDate={savedEndDate}
        handleClearDates={handleClearDates}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        handleSaveDate={handleSaveDate}
        startDate={startDate}
        endDate={endDate}
      />
    </div>
  );
};

export default UserEarning;
